import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('gold_mine', {
  cherry: 'pickaxe',
  lemon: 'lantern',
  orange: 'ore_cart',
  bell: 'dinner_bell',
  star: 'gold_nugget_wild',
  seven: 'mine_entrance',
  gem: 'raw_gold',
  scatter: 'dynamite_scatter',
  money: 'gold_scale',
});

/** Gold Mine — GENERATED by scaffoldSlot from
 *  content/slots/gold_mine.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const GOLD_MINE_THEME: Theme = {
  id: 'gold_mine',
  name: 'Gold Mine',
  palette: {
    accent: 0xc68a3a,
    secondary: 0xd9b06a,
    warm: 0xf2d27a,
    frameFill: 0x2a1d12,
    bgGradientTop: 0x4a3320,
    bgGradientBottom: 0x1a1009,
    dimOverlay: 0x0d0805,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Pickaxe', glyph: '⛏️', tint: 0x9a6a3a, weight: 5, textureAlias: 'gold_mine:cherry',
        winVideoAlias: 'gold_mine:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Mine Lantern', glyph: '🏮', tint: 0xe0a83a, weight: 5, textureAlias: 'gold_mine:lemon',
        winVideoAlias: 'gold_mine:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Ore Cart', glyph: '🛒', tint: 0xa06a3a, weight: 4, textureAlias: 'gold_mine:orange',
        winVideoAlias: 'gold_mine:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Camp Bell', glyph: '🔔', tint: 0xd0a84e, weight: 3, textureAlias: 'gold_mine:bell',
        winVideoAlias: 'gold_mine:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Gold Strike', glyph: '⛏️', tint: 0xf0c84e, weight: 2, textureAlias: 'gold_mine:star',
        winVideoAlias: 'gold_mine:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Gold Mine', glyph: '⛰️', tint: 0x8a6a4a, weight: 2, textureAlias: 'gold_mine:seven',
        winVideoAlias: 'gold_mine:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Gold Vein', glyph: '💛', tint: 0xf0c84e, weight: 2.5, textureAlias: 'gold_mine:gem',
        winVideoAlias: 'gold_mine:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Dynamite', glyph: '🧨', tint: 0xc0392b, weight: 0.5, textureAlias: 'gold_mine:scatter',
        winVideoAlias: 'gold_mine:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Gold Scale', glyph: '💰', tint: 0xf0c860, weight: 1, textureAlias: 'gold_mine:money',
        winVideoAlias: 'gold_mine:money:win:video', winVideoSpeed: 2, isMoney: true },
      // Gem-on-reel — producer brief 2026-06-04. Scatter-style bonus
      // shared across every biome (registered via SHARED_REEL_SYMBOLS
      // in themes/index.ts). Weights deliberately rare so a gem
      // landing feels like a treat rather than background noise.
      { id: 'gem_t5',  label: 'Gems',     glyph: '💎', tint: 0x3ea7e8, weight: 0.10, gemValue: 5,  textureAlias: 'shared:reel:gem_5' },
      { id: 'gem_t10', label: 'Gem Pile', glyph: '💎', tint: 0x3ea7e8, weight: 0.05, gemValue: 10, textureAlias: 'shared:reel:gem_10' },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x2a1d12, multiplier: 0, weight: 3 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0xc68a3a, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 4 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0xd9b06a, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0xc68a3a, multiplier: 1, weight: 4 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x2a1d12, multiplier: 0, weight: 2 },
      { id: 'x3-b', kind: 'multiplier', label: '×3', tint: 0xd9b06a, multiplier: 3, weight: 3 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0xc68a3a, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x15-a', kind: 'multiplier', label: '×15', tint: 0xf2d27a, multiplier: 15, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'gold_mine:bg', path: 'environment/gold_mine.png' },
      columnBackground: { alias: 'gold_mine:column_bg', path: 'reel/gold_mine_column_bg.png' },
      border: { alias: 'gold_mine:border', path: 'brand/border_frontier.png' },
    },
  },
};
